import { render, staticRenderFns } from "./WindowStackView.vue?vue&type=template&id=4969241c&scoped=true&"
import script from "./WindowStackView.vue?vue&type=script&lang=js&"
export * from "./WindowStackView.vue?vue&type=script&lang=js&"
import style0 from "./WindowStackView.vue?vue&type=style&index=0&id=4969241c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969241c",
  null
  
)

export default component.exports